// Session state. The access token lives in memory only (02 §5.1); the refresh token is an httpOnly
// cookie the browser sends to /api/v1/auth.
import type { Account } from '@stars-and-ships/api-types';
import { create } from 'zustand';

export type SessionStatus = 'unknown' | 'anonymous' | 'authenticated';

interface SessionState {
  status: SessionStatus;
  accessToken: string | null;
  account: Account | null;
  setAccessToken(accessToken: string): void;
  signIn(accessToken: string, account: Account): void;
  setAccount(account: Account): void;
  clear(): void;
}

export const useSession = create<SessionState>()((set) => ({
  status: 'unknown',
  accessToken: null,
  account: null,
  setAccessToken: (accessToken) => set({ accessToken }),
  signIn: (accessToken, account) => set({ accessToken, account, status: 'authenticated' }),
  setAccount: (account) => set({ account }),
  clear: () => set({ accessToken: null, account: null, status: 'anonymous' }),
}));
